import { StockIpoReservationAction } from './stock-ipo-reservation.action';
import { IIpoReservation } from '../../partials/stock-ipo/interfaces/ipo-reservation.interface';


export interface IIpoReservationState {
    newIpoReservation: IIpoReservation;
    loading: boolean;
    reservationCreated: boolean;
    userIposReservations: IIpoReservation[];
    error: boolean;
}

export const initialState: IIpoReservationState = {
    loading: false,
    newIpoReservation: null,
    reservationCreated: false,
    userIposReservations: [],
    error: false,
};

export function StockIpoReservationReducer(state: IIpoReservationState = initialState, action?: StockIpoReservationAction) {
    switch (action.type) {
        case StockIpoReservationAction.createIpoReservation:
            return { ...state, newIpoReservation: action.payload, loading: true, reservationCreated: false, error: false };
        case StockIpoReservationAction.createIpoReservationSuccess:
            return { ...state, loading: false, reservationCreated: true, userIposReservations: [...state.userIposReservations, action.payload], error: false };
        case StockIpoReservationAction.ipoReservationError:
            return { ...state, loading: false, reservationCreated: false, error: true };
        case StockIpoReservationAction.finishIpoReservation:
            return { ...state, reservationCreated: false, newIpoReservation: {}, error: false };
        case StockIpoReservationAction.getIpoReservationsByCBLC:
            return { ...state, loading: true, error: false };
        case StockIpoReservationAction.getIpoReservationsByCBLCSuccess:
            return { ...state, loading: false, userIposReservations: action.payload, error: false };
        default:
            return state;
    }
}